module.exports = __webpack_public_path__ + "static/img/1.9d171cf0.png";